// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1CYIr","buttons":"SendReceipts_buttons__1IwBH","email":"SendReceipts_email__RQWBQ","bookApptTitle":"SendReceipts_bookApptTitle__28Pal"};